module.exports = __webpack_public_path__ + "img/ib-chemistry-flutter.e0788202.png";